export default __webpack_public_path__ + "static/media/avatar.6cc3e2ed.png";